import {Component, Input, OnInit} from '@angular/core';
import {chartConfig, NumberUnit} from '../../app.constants';
import {PdfExportService} from '../../services/export-pdf/pdf-export.service';
import {UserService} from '../../services/user.service';
import {NumberUtils} from '../../utils/number.utils';

@Component({
  selector: 'achoo-column-chart',
  templateUrl: './achoo-column-chart.component.html',
  styleUrls: ['./achoo-column-chart.component.scss']
})
export class AchooColumnChartComponent implements OnInit {
  @Input() chartData: Array<object>;
  @Input() chartTitle: string | null;
  @Input() width: number;
  @Input() height: number;
  @Input() maxWidthLabel;
  @Input() isFallbackView = false;
  @Input() titleStyling: {
    fontSize: '0.99rem'
  };
  @Input() chartCustomConfig: {
    pointWidth: number,
    marginBottom: number,
    fontSize: number
  };
  @Input() titleTooltip: string;
  options: object;
  constructor(protected pdfService: PdfExportService,
              protected userService: UserService) { }

  ngOnInit() {
    const marginBottom = this.chartCustomConfig && this.chartCustomConfig.marginBottom ? this.chartCustomConfig.marginBottom : chartConfig.columnChart.marginBottom;
    const pointWidth = this.chartCustomConfig && this.chartCustomConfig.pointWidth ? this.chartCustomConfig.pointWidth : chartConfig.columnChart.pointWidth;
    const fontSize = this.chartCustomConfig && this.chartCustomConfig.fontSize ? this.chartCustomConfig.fontSize : chartConfig.defaultFontSize;
    let legendmMaxWidthLabel = 40; // default max with for legend lable
    if (this.maxWidthLabel) {
      legendmMaxWidthLabel = this.maxWidthLabel;
    } else {
      legendmMaxWidthLabel = this.chartData && this.chartData.length > 0 ? 350 / (this.chartData.length) : 0;
    }
    this.options = {
      chart: {
        type: chartConfig.type.column,
        zoomType: 'x',
        width: this.width,
        height: this.height,
        backgroundColor: chartConfig.transparentBackground,
        style: {
          fontFamily: chartConfig.font.light,
        },
        marginTop: chartConfig.columnChart.marginTop,
        marginBottom: marginBottom,
        marginRight: chartConfig.columnChart.marginRight,
        marginLeft: chartConfig.columnChart.marginLeft
      },
      colors: this.isFallbackView ? [chartConfig.fallbackViewColor] : this.userService.chartColors,
      tooltip: {
        enabled: false
      },
      plotOptions: {
        column: {
          dataLabels: {
            enabled: false,
          },
          showInLegend: false,
          colorByPoint: true,
          borderRadiusTopLeft: chartConfig.columnChart.borderRadiusTop,
          borderRadiusTopRight: chartConfig.columnChart.borderRadiusTop
        },
        series: {
          borderWidth: 0,
          dataLabels: {
            allowOverlap: true,
            enabled: true,
            crop: false,
            overflow: 'none',
            formatter: function () {
              return this.point.isFaking ? '<span class="fake-column-label" style="display: block; font-size: 30px; color: #95A0B1;">.</span>'
                : this.y > NumberUnit.BILLION ? '+1B' : NumberUtils.formatNumberToString(this.y);
            },
            useHTML: true,
            style: {
              fontSize: fontSize + 'px'
            }
          },
          pointWidth: pointWidth,
          states: {
            hover: {
              enabled: false
            }
          },
          animation: !this.pdfService.exportingPdf
        }
      },
      credits: {
        enabled: false
      },
      series: [{
        data: this.chartData
      }],
      title: {
        text : this.chartTitle,
        // REVIEW: Do we need to add this elsewhere?
        style: Object.assign({}, chartConfig.defaultTitleStyling, this.titleStyling),
        align: chartConfig.title.align,
        x: chartConfig.title.padding,
        y: chartConfig.title.padding
      },
      xAxis: {
        type: chartConfig.xAxis.type,
        className: 'achoo-column-xaxis',
        labels: {
          rotation: 0,
          padding: chartConfig.columnChart.labelsPadding,
          useHTML: true,
          enabled: !this.isFallbackView,
          style: {
            fontSize: fontSize + 'px',
            maxWidth: legendmMaxWidthLabel + 'px',
            color: chartConfig.defaultColor,
            overflow: 'hidden',
            textOverflow: 'ellipsis'
          }
        },
        tickLength: 0,
      },
      yAxis: {
        gridLineWidth: 0,
        minorGridLineWidth: 0,
        lineColor: chartConfig.yAxis.lineColor,
        title: {
          text: false
        },
        labels: {
          enabled: false
        }
      },
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/core/achoo-column-chart/achoo-column-chart.component.ts